import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { usePrestacaoContasState } from "../context/prestacao-contas-context";
import { usePrestacaoContasController } from "../context/prestacao-contas-controller";
import { PrestacaoContasForm } from "./prestacao-contas-form";

export const PrestacaoContasDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = usePrestacaoContasController();
    const { dataResponse, showAddEdit } = usePrestacaoContasState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Prestação de Contas ${dataResponse?.id}`;
        return "Adicionar Prestação de Contas";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <PrestacaoContasForm />
        </DefaultDrawer>
    );
};
